import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Rotas onde o botão fica escondido (raiz, entrar, etc).
const HIDE_PATHS = new Set([
  "/", "/entrar", "/cadastro", "/atendimento",
]);

/**
 * Botão flutuante "Voltar" que aparece em toda página que não seja
 * a home / auth. Usa `navigate(-1)` quando há histórico; senão volta
 * pro parent inferido da URL.
 */
export const BackButton = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  if (HIDE_PATHS.has(pathname)) return null;

  const goBack = () => {
    if (window.history.length > 1) {
      nav(-1);
      return;
    }
    // fallback: sobe um nível na URL
    const parts = pathname.replace(/\/$/, "").split("/");
    parts.pop();
    nav(parts.join("/") || "/");
  };

  return (
    <button onClick={goBack} data-testid="global-back-btn" aria-label="Voltar"
      className="inline-flex items-center gap-1.5 text-xs text-slate-600 hover:text-[#0B2B62] bg-white border border-slate-200 hover:border-slate-300 shadow-sm rounded-full pl-2.5 pr-3.5 py-1.5 transition-colors">
      <ArrowLeft className="w-3.5 h-3.5" strokeWidth={2} />
      <span className="font-medium">Voltar</span>
    </button>
  );
};

export default BackButton;
